import { useJsApiLoader } from '@react-google-maps/api'

/** Shared script id — Loader is a singleton; options must never diverge across call sites. */
export const GOOGLE_MAPS_LOADER_ID = 'google-map-profile'

/**
 * Single entry point for loading the Google Maps JS API.
 * All map components should use this so Loader options stay identical.
 * Otherwise we get an error about conflicting script ids.
 * @returns {{ isLoaded: boolean, loadError: Error | undefined, apiKey: string }}
 */
export default function useGoogleMapsLoader() {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

  const { isLoaded, loadError } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: apiKey,
  })

  return { isLoaded, loadError, apiKey }
}
